// 封装的axios请求
import axios from 'axios'
import qs from 'querystring'

// 定义响应错误函数处理协议状态码信息提示
/**
 * status: 状态
 * info: 错误信息
 */
const errorHandle = (status, info) => {
    switch (status) {
        case 400:
            console.log("表示请求报文中存在错误");
            break;
        case 401:
            console.log("未经许可，需要http认证");
            break;
        case 403:
            console.log("服务器拒绝该次访问(访问权限出现问题)");
            break;
        case 404:
            console.log("表示服务器上无法找到请求的资源");
            break;
        case 500:
            console.log("表示服务器在执行请求时发生了错误");
            break;
        case 503:
            console.log("表示服务器暂时处于超负载或正在进行停机维护");
            break;
        case 504:
            console.log("(网关超时) 服务器作为网关或代理，但是没有及时从上游服务器收到请求");
            break;
        default:
            console.log(info);
            break;
    }
}

// 创建实例
const instance = axios.create({
    timeout: 5000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': '*/*'
    }
})

// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 拦截器
instance.interceptors.request.use(
    // 成功的函数
    config => {
        if (config.methods == "post") {
            config.data = qs.stringify(config.data)
        }

        return config;
    },
    // 失败的函数
    error => {
        return Promise.reject(error)
    }
)

// 获取数据之前
instance.interceptors.response.use(
    // 成功
    response => {
        return response.status === 200 ? Promise.resolve(response) : Promise.reject(response)
    },
    // 失败
    error => {
        const { response } = error;
        // 错误处理
        errorHandle(response.status, response.info)
    }
)

// 导出
export default instance;

